import { FC } from 'react'
import { Container } from './payment-checkout.styled'
import { PaymentMethods } from './payment-methods'

export const PaymentCheckout: FC = () => {
  return (
    <Container>
      <PaymentMethods />
    </Container>
  )
}
